// PublicRoute Component - redirects authenticated users away from public pages
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from "@/app/providers";

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { token, loading } = useAuth();
  const location = useLocation();

  // While auth initializes or refreshes, keep rendering public content
  // to avoid a white screen flicker on the login page.
  if (loading) {
    return <>{children}</>;
  }

  // If user is authenticated, redirect to calendar (home page)
  if (token) {
    // Get the intended destination from state, or default to calendar
    const from = location.state?.from?.pathname || '/';
    return <Navigate to={from} replace />;
  }

  // Render public content (login page)
  return <>{children}</>;
};

export default PublicRoute;
